export default __webpack_public_path__ + "0704d60b03fc2e7e4399efe804c21b74.png";